export const MEMBER_BLOCKER_AUCTION_RUNNING_OR_SCHEDULED_SOON = 'member.blocker.auctionRunningOrScheduledSoon';
export const MEMBER_BLOCKER_AUCTIONEER_IN_AUCTION = 'member.blocker.auctioneerInAuction';
export const MEMBER_BLOCKER_AUCTION_LIMIT_DEFINED = 'member.blocker.auctionLimitDefined';
export const MEMBER_BLOCKER_USER_ASSIGNED = 'member.blocker.userAssigned';
export const MEMBER_BLOCKER_MEMBER_HAS_BIDS = 'member.blocker.memberHasBids';
export const MEMBER_BLOCKER_AUCTIONEER_IN_UNFINISHED_AUCTION = 'member.blocker.auctioneerInUnfinishedAuction';

export const transformMemberBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case MEMBER_BLOCKER_AUCTION_RUNNING_OR_SCHEDULED_SOON:
            result = t('members.blocker.auction-running-or-scheduled-soon');
            break;
        case MEMBER_BLOCKER_AUCTIONEER_IN_AUCTION:
            result = t('members.blocker.auctioneer-in-auction');
            break;
        case MEMBER_BLOCKER_AUCTION_LIMIT_DEFINED:
            result = t('members.blocker.auction-limit-defined');
            break;
        case MEMBER_BLOCKER_USER_ASSIGNED:
            result = t('members.blocker.user-assigned');
            break;
        case MEMBER_BLOCKER_MEMBER_HAS_BIDS:
            result = t('members.blocker.member-has-bids');
            break;
        case MEMBER_BLOCKER_AUCTIONEER_IN_UNFINISHED_AUCTION:
            result = t('members.blocker.auctioneer-in-unfinished-auction');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
